module.exports = __webpack_public_path__ + "img/nabl_gallery1.337fea0f.jpg";